module.exports = __webpack_public_path__ + "img/3-7.4405ecb7.png";